module.exports = __webpack_public_path__ + "static/media/2018-23-hn.e98e447c.png";